import React, { useEffect, useRef, useState } from "react"
import { Link, useSearchParams } from "react-router-dom"
import { api } from "../api/client"
import { useLanguage } from "../context/LanguageContext"
import AuthSceneShell, { useAuthSceneParallax } from "../components/AuthSceneShell"
import PasswordInput from "../components/PasswordInput"

export default function ResetPassword() {
  const { t } = useLanguage()
  const [searchParams] = useSearchParams()
  const token = (searchParams.get("token") || "").trim()
  const [password, setPassword] = useState("")
  const [confirm, setConfirm] = useState("")
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState("")
  const shapesRef = useRef(null)

  useAuthSceneParallax(shapesRef)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const onSubmit = async (event) => {
    event.preventDefault()
    setError("")
    if (!token) {
      setError(t("resetPasswordInvalid"))
      return
    }
    if (password !== confirm) {
      setError(t("passwordsDoNotMatch"))
      return
    }
    setLoading(true)
    try {
      await api.resetPassword({ token, password })
      setDone(true)
    } catch (exc) {
      setError(exc.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthSceneShell shapesRef={shapesRef}>
      <div className="auth-layout">
        <div className="auth-form-panel">
          <div className="auth-portal-stack w-full max-w-sm mx-auto">
            <h1 className="auth-form-title">{t("resetPassword")}</h1>

            <div className="auth-panel-3d auth-registration-card auth-portal-card">
              {done ? (
                <div className="auth-form">
                  <p className="auth-form-hint" role="status">
                    {t("resetPasswordSuccess")}
                  </p>
                  <Link to="/login" viewTransition className="button-glow auth-submit">
                    {t("backToSignIn")}
                  </Link>
                </div>
              ) : (
                <form className={`auth-form${loading ? " auth-form--busy" : ""}`} onSubmit={onSubmit}>
                  {error ? (
                    <div className="auth-alert" role="alert">
                      <span className="auth-alert-text">{error}</span>
                      <button
                        type="button"
                        onClick={() => setError("")}
                        className="auth-alert-dismiss"
                        aria-label={t("dismiss")}
                      >
                        ×
                      </button>
                    </div>
                  ) : null}

                  {!token ? (
                    <p className="auth-form-hint">{t("resetPasswordInvalid")}</p>
                  ) : (
                    <>
                      <p className="auth-form-hint">{t("resetPasswordLead")}</p>

                      <div className="auth-field">
                        <label htmlFor="password">{t("newPassword")}</label>
                        <PasswordInput
                          id="password"
                          name="password"
                          required
                          autoComplete="new-password"
                          value={password}
                          onChange={(event) => setPassword(event.target.value)}
                        />
                      </div>

                      <div className="auth-field">
                        <label htmlFor="confirm">{t("confirmNewPassword")}</label>
                        <PasswordInput
                          id="confirm"
                          name="confirm"
                          required
                          autoComplete="new-password"
                          value={confirm}
                          onChange={(event) => setConfirm(event.target.value)}
                        />
                      </div>

                      <button type="submit" disabled={loading} aria-busy={loading} className="button-glow auth-submit">
                        {loading ? t("saving") : t("resetPasswordSubmit")}
                      </button>
                    </>
                  )}
                </form>
              )}

              <div className="auth-form-footer">
                <p>
                  <Link to="/login" viewTransition className="auth-text-link">
                    {t("backToSignIn")}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthSceneShell>
  )
}
